import { FaHome, FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useGetData, useGetToken } from "../hooks/custom-hooks";
import { getReprocessRollupCount } from "../services/dimension-service";
import Loader from "../navigation/Loader";
import { LoadingTable } from "../shared/LoadingTable";
import { DimTablesPeek } from "../partials/DimTablesPeek";
import { getBIParams } from "../services/dimension-service";
import { DimTablesPeekCard } from "../partials/DimTablesPeekCard";
import { ReprocessRollUp } from "../partials/ReprocessRollUp";
import { AddFactRowModal } from "../pop-ups/add-fact-row";


export const CommerceManagement = () => {
    const navigate = useNavigate();
    const token = useGetToken();
    
    const [loading, setLoading] = useState(true);
    const [reprocessCount, setReprocessCount] = useState();
    const [addFactRowModalOpen, setAddFactRowModalOpen] = useState(false);

    const dimTableType = "commerce";

    const handleBackBtn = () => {
        navigate(`/`);
    }
    useEffect(() => {

        if (token !== null) {
            const getBIVariables = async () => {

                let currentParams = await getBIParams(token);

                let reprocessCountResult = await getReprocessRollupCount(dimTableType, token);
                setReprocessCount(reprocessCountResult?.data?.count ?? 0);

                setLoading(false);
            }
            getBIVariables(); 
        }
    }, [token]);

    if(loading) {
        return (
            <div className="App">
                <LoadingTable/>
            </div>            
        );
    }

    return (
        <div className="App">
            <div className="header-content commerce-header">
                <div className="landing-page-actions">
                    <span className="App-text back-btn" onClick={handleBackBtn}>
                        <FaHome /> Home
                    </span>
                    <div className="commerce-home-header-actions">
                        <ReprocessRollUp 
                            rollupType={"concessionsRollup"}
                            reprocessCount={reprocessCount}
                        />
                        <div className="module-container-slim" onClick={() => setAddFactRowModalOpen(true)}>
                            <div className="icon-text-row App-text">
                                <div className="icon-text-row App-text"><FaPlus className='teal-icons'/> Add Fact Row</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="page-header">
                    <h1>Commerce Management</h1>
                    <p>Dimension Tables Overview</p>
                </div>
            </div>

            <DimTablesPeekCard />

        {addFactRowModalOpen && (
            <AddFactRowModal
                isOpen={addFactRowModalOpen}
                config={{ /* your config here */ }}
                onClose={() => setAddFactRowModalOpen(false)}
            />
        )}
        </div>

    );
};
